import { render, staticRenderFns } from "./AdminUploadDocuments_old.vue?vue&type=template&id=09c44f51&scoped=true&"
import script from "./AdminUploadDocuments_old.vue?vue&type=script&lang=js&"
export * from "./AdminUploadDocuments_old.vue?vue&type=script&lang=js&"
import style0 from "./AdminUploadDocuments_old.vue?vue&type=style&index=0&id=09c44f51&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c44f51",
  null
  
)

export default component.exports